import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import format from 'date-fns/format';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import Pagination from '../../../components/Pagination/Pagination';
import CustomTable from '../../../components/Table/Table';
import FormDialog from '../../../components/Dialog/FormDialog';
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import Snackbar from '../../../components/Snackbar/Snackbar';
import {
    organizerType, locationOption,
} from '../../../common/Constants';
import Typography from '../../../components/Typography/CustomTypography';
import AlertDialog from '../../../components/Dialog/AlertDialog';
import Loader from '../../../components/Loader/Loader';
import Button from '../../../components/Button/CustomButton';
import { DownloadIcon } from '../../../components/Icons/Icon';

const ListViewer = (props) => {
    const {
        fetchListViewer,
        clearViewer,
        viewerResults,
        viewerUpdate,
        viewers,
        errors,
        options,
        isLoading,
        resendMail,
        resendMailSuccess,
        resetResendMailData,
        getCsvViewer, getCsvViewerClear, viewerDownloadData, successGetDownloadData,
    } = props;
    const routeParams = useParams();
    const [viewerList, setViewerList] = useState([]);
    const [openDialogDetail, setOpenDialogDetail] = useState(false);
    const [stateDetail, setStateDetail] = useState([]);
    const [currentPage, setCurrentPage] = useState();
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });
    const [dialogConfirm, setDialogConfirm] = useState({
        isOpen: false,
        handleClose: () => { },
        handleSubmit: () => { },
        contents: '',
    });
    const [listOptionCompanyFromApi, setListOptionCompanyFromApi] = useState({});
    const [listPurposeOptionFromApi, setListPurposeOptionFromApi] = useState({});
    const [listOptionAgeRangeFromApi, setOptionAgeRangeFromApi] = useState({});
    const [listPurposeAnotherOptionFromApi, setListPurposeAnotherOptionFromApi] = useState({});
    const [listOptionEmployeeNumberFromApi, setOptionEmployeeNumberFromApi] = useState({});

    // resend mail
    const [isOpenResendMailConfirmDialog, setOpenResendMailConfirmDialog] = useState(false);
    const [isOpenResendMailSuccessSnackbar, setOpenResendMailSuccessSnackbar] = useState(false);
    const userIdSelectedRef = useRef('');

    useEffect(() => {
        const { shortName } = routeParams;
        fetchListViewer({
            event_name: shortName,
            page: 1,
            page_size: 20,
        });
        return () => {
            clearViewer();
            getCsvViewerClear();
        };
    }, [routeParams]);

    useEffect(() => {
        const { shortName } = routeParams;
        setDialogConfirm({ ...dialogConfirm, isOpen: false });
        setOpenDialogDetail(false);
        fetchListViewer({
            event_name: shortName,
            page: currentPage,
            page_size: 20,
        });
        if (viewerUpdate.id) {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'success',
                message: <FormattedMessage id="apiSuccess.default" />,
            });
        }
    }, [viewerUpdate]);

    useEffect(() => {
        if (errors && errors.code === 'BAD_REQUEST') {
            setDialogConfirm({ ...dialogConfirm, isOpen: false });
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: errors.message.message,
            });
        }
    }, [errors]);

    useEffect(() => {
        if (!_.isEmpty(viewerResults)) {
            const tableData = viewerResults.map((viewer) => [
                viewer.email,
                // organizerType[viewer.viewer_type],
                renderViewerType(viewer.viewer_type, viewer.viewer_live_stream),
                viewer.uuid,
                viewer.work_place,
                `${viewer.first_name} ${viewer.last_name}`,
                <Box display="flex" alignItems="center" justifyContent="center">
                    <Button onClick={(event) => onResendMail(event, viewer.id)} style={{ fontSize: '14px' }}>再送信</Button>
                </Box>,
            ]);
            setViewerList(tableData);
        }
    }, [viewerResults]);

    // Set list Option Company
    useEffect(() => {
        if (options && options.company_option) {
            let temp = {};
            options.company_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListOptionCompanyFromApi({ ...listOptionCompanyFromApi, ...temp });
        }
    }, [options]);

    // Set list Option purpose
    useEffect(() => {
        if (options && options.purpose_option) {
            let temp = {};
            options.purpose_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListPurposeOptionFromApi({ ...listPurposeOptionFromApi, ...temp });
        }
    }, [options]);

    // Set list seminar_option(AnotherOption)
    useEffect(() => {
        if (options && options.seminar_option) {
            let temp = {};
            options.seminar_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListPurposeAnotherOptionFromApi({ ...listPurposeAnotherOptionFromApi, ...temp });
        }
    }, [options]);

    // Set list Option age
    useEffect(() => {
        if (options && options.age_range_option) {
            let temp = {};
            options.age_range_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionAgeRangeFromApi({ ...listOptionAgeRangeFromApi, ...temp });
        }
    }, [options]);

    // Set list employee_number
    useEffect(() => {
        if (options && options.employee_number_option) {
            let temp = {};
            options.employee_number_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionEmployeeNumberFromApi({ ...listOptionEmployeeNumberFromApi, ...temp });
        }
    }, [options]);

    useEffect(() => {
        if (resendMailSuccess) {
            resetResendMailData(); // reset data resend mail in redux store
            userIdSelectedRef.current = ''; // reset selected user id
            setOpenResendMailSuccessSnackbar(true);
        }
    }, [resendMailSuccess]);

    useEffect(() => {
        if (viewerDownloadData && successGetDownloadData) {
            const downloadLink = document.createElement('a');
            const blob = new Blob(['\ufeff', viewerDownloadData]);
            const url = URL.createObjectURL(blob);
            downloadLink.href = url;
            const dateDownload = format(new Date(), 'yyyy-MM-dd_HH-mm-ss');
            downloadLink.download = `入場者一覧${`${routeParams.shortName}_${dateDownload}`}.csv`;

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }, [viewerDownloadData, successGetDownloadData, routeParams.shortName]);

    const renderViewerType = (typeSeminarAndBooth, typeLiveStream) => {
        let result = '';
        if (typeSeminarAndBooth === 0 && !typeLiveStream) {
            return '';
        }
        if (typeSeminarAndBooth === 3 && typeLiveStream) {
            return '展示会・セミナー・ライブ配信';
        }
        if (typeSeminarAndBooth === 3 && !typeLiveStream) {
            return '展示会・セミナー';
        }
        if (typeSeminarAndBooth === 1) {
            result = '展示会';
        }
        if (typeSeminarAndBooth === 2) {
            result = 'セミナー';
        }
        if (typeLiveStream && !result) {
            return 'ライブ配信のみ';
        }
        if (typeLiveStream && result) {
            result = result.concat('・ライブ配信');
        } else {
            result = result.concat('のみ');
        }
        return result;
    };

    const handleSearchWithPage = (page) => {
        setCurrentPage(page);
        if (fetchListViewer) {
            const { shortName } = routeParams;
            fetchListViewer({
                event_name: shortName,
                page_size: 20,
                page,
            });
        }
    };
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    const onResendMail = (event, userId) => {
        event.stopPropagation();
        userIdSelectedRef.current = userId;
        setOpenResendMailConfirmDialog(true);
    };

    const handleSubmitResendMail = () => {
        if (resendMail) {
            resendMail({
                user_id: userIdSelectedRef.current,
            });
            setOpenResendMailConfirmDialog(false);
        }
    };

    const handleShowDialogTitle = (index) => {
        if (viewerResults[index]) {
            const data = viewerResults[index];
            setOpenDialogDetail(true);
            const detail = [
                {
                    name: '氏名',
                    value: `${data.first_name} ${data.last_name}`,
                },
                {
                    name: 'メールアドレス',
                    value: data.email,
                },
                {
                    name: '申込種別',
                    // value: organizerType[data.viewer_type],
                    value: renderViewerType(data.viewer_type, data.viewer_live_stream),
                },
                {
                    name: '職場先',
                    value: data.work_place,
                },
                {
                    name: '国・地域',
                    value: locationOption.ja[data.location],
                },
                {
                    name: '年齢',
                    value: listOptionAgeRangeFromApi[data.age_range],
                },
                {
                    name: '郵便番号',
                    value: data.zip_code,
                },
                {
                    name: '住所',
                    value: data.address,
                },
                {
                    name: '部署',
                    value: data.department,
                },
                {
                    name: '役職',
                    value: data.position,
                },
                {
                    name: '電話番号',
                    value: data.phone_number,
                },
                {
                    name: 'FAX番号',
                    value: data.fax_number,
                },
                {
                    name: '業種',
                    value: data.job,
                },
                {
                    name: '職種',
                    value: data.occupation_name,
                },
                {
                    name: '従業員数',
                    value: listOptionEmployeeNumberFromApi[data.employee_number],
                },
                {
                    name: '入場目的',
                    value: Number(data.purpose === Object.keys(listPurposeOptionFromApi).length - 1) ? data.additional_purpose : listPurposeOptionFromApi[data.purpose],
                },
                {
                    name: 'セミナー受講目的',
                    value: listPurposeAnotherOptionFromApi[data.purpose_another],
                },
            ];
            setStateDetail(detail);
        }
    };

    const handleGetCSV = (shortName) => {
        getCsvViewer({ shortName });
    };

    return (
        <>
            {viewerList?.length > 0 && (
                <div style={{ textAlign: 'center' }}>
                    <Button
                        color="info"
                        gradient
                        size="md"
                        round
                        onClick={() => handleGetCSV(routeParams.shortName)}
                        download
                    >
                        <DownloadIcon />
                        &#160;
                        CSVダウンロード
                    </Button>
                </div>
            )}

            <CustomTable
                onClick={(index) => handleShowDialogTitle(index)}
                tableHead={['メールアドレス', '登録種別', 'アカウントID', '勤務先', '氏名', 'ログイン通知再送']}
                tableHeadWidth={['20%', '20%', '15%', '20%', '15%', '10%']}
                tableData={viewerList}
                tableFooter={(
                    <Box display="flex" justifyContent="center">
                        <Pagination
                            page={viewers.page}
                            total={viewers.total_page}
                            onChange={(page) => handleSearchWithPage(page)}
                        />
                    </Box>
                )}
            />
            <FormDialog
                title="入場者情報"
                isOpen={openDialogDetail}
                handleClose={() => setOpenDialogDetail(false)}
            >
                <div>
                    {
                        !_.isEmpty(stateDetail) && stateDetail.map((prop) => (
                            <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                                <GridItem md={1} />
                                <GridItem md={2}>
                                    <Typography bold>
                                        {prop.name}
                                    </Typography>
                                </GridItem>
                                <GridItem md={9}>
                                    <Typography>
                                        {prop.value}
                                    </Typography>
                                </GridItem>
                            </GridContainer>
                        ))
                    }
                </div>
            </FormDialog>
            <Snackbar
                open={snackbar.isOpen}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                severity={snackbar.type}
            />
            <AlertDialog
                handleOpen={dialogConfirm.isOpen}
                handleClose={dialogConfirm.handleClose}
                handleSubmit={dialogConfirm.handleSubmit}
                contents={dialogConfirm.contents}
            />
            <AlertDialog
                contents="メールを再送信しますが、よろしいでしょうか？。"
                handleOpen={isOpenResendMailConfirmDialog}
                handleClose={() => setOpenResendMailConfirmDialog(false)}
                handleSubmit={handleSubmitResendMail}
            />
            <Snackbar
                severity="success"
                message="メールを成功に再送信しました。"
                open={isOpenResendMailSuccessSnackbar}
                onClose={() => setOpenResendMailSuccessSnackbar(false)}
            />
            <Loader isLoading={isLoading} />
        </>
    );
};

ListViewer.defaultProps = {
    viewerResults: [],
    viewers: {},
    viewerUpdate: {},
    errors: {},
    options: {},
    resendMail: () => { },
    resetResendMailData: () => { },
    resendMailSuccess: false,
};

ListViewer.propTypes = {
    fetchListViewer: PropTypes.func.isRequired,
    clearViewer: PropTypes.func.isRequired,
    updateViewer: PropTypes.func.isRequired,
    viewerResults: PropTypes.oneOfType([() => null, PropTypes.array]),
    viewers: PropTypes.oneOfType([() => null, PropTypes.object]),
    viewerUpdate: PropTypes.oneOfType([() => null, PropTypes.object]),
    errors: PropTypes.oneOfType([() => null, PropTypes.object]),
    options: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLoading: PropTypes.bool.isRequired,
    resendMail: PropTypes.func,
    resetResendMailData: PropTypes.func,
    resendMailSuccess: PropTypes.bool,
};

export default ListViewer;
